import angular from 'angular';
import { dateWithValidator as dateFilter } from 'Common/utilities/date';

const dateWithValidator = () => dateFilter;
export const loadModule = () =>
  angular.module('app').filter('dateWithValidator', dateWithValidator);
